import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Blog } from "./pages/blog";
import { Projects } from "./pages/projects";
import { Contact } from "./pages/contact";
import { About } from "./pages/about";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import styles from "./styles/layout/App.module.css";

/**
 * Main App component with routing and global layout
 * Uses Header and Footer components for consistent layout across all pages
 */
const App = () => {
  return (
    <Router>
      <div className={styles.appContainer}>
        <Header />
        
        <main className={styles.mainContent}>
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/" element={<About />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
};

export default App;
